export interface PricesList{
    [key:number]:number;
}

export class Prices implements PricesList {
    [key: number]: number;
  
    get isReady() {
      return Object.keys(this).length > 0;
    }
  }

export interface Rates {
    [key:string]:number;
}

export class pricesRatesDto{
    public pricesList:PricesList;
    public monthlyPricesList?:PricesList; // GBP per seat per MONTH; present only when monthly billing is available
    public rates:Rates;
    public currency?: string; // "GBP" or "EUR" (EU visitors)
    constructor(priceList:PricesList, rates:Rates){
        this.pricesList = priceList;
        this.rates = rates;
    }
}

// export interface PurchaseDto{
//     Qnt:number;
//     Name?:string;
//     Address?:string;
//     BuyersRefNumber?:string;
//     CountryIsoCode?:string;
//     InvoiceNeeded:boolean;
//     BuyersVatNumber?:string;
//     DiscountCode?:string;
// }

export interface CheckDiscountCodeResponseDto
{
    isDiscountCodeValid:boolean;
    valitTo:Date;
    discountPercentage:number;
    discountCode:string;
    discountCodeError:string;
    minimumPurchaseQnt:number;
}

export interface CountryDto{
    name:string;
    code:string;
    taxRate:number;
}

export interface CountriesDto{  
    detectedCountryCode:string;
    countries:CountryDto[];
}


export interface PurchaseDto {
    Url: string;
    Qnt: number;
    Name?: string;
    Address?: string;
    BuyersRefNumber?: string;
    CountryIsoCode?: string;
    InvoiceNeeded: boolean;
    BuyersVatNumber?: string;
    DiscountCode?: string;
    BillingPeriod?: string; // "monthly" | "annual" (default annual)
  }

  export interface PaidOrderDto {
    error: string | null;
    pending: boolean;
    paymentId: number;
    orderId: number;
    subscribtionEndDate: string;
    numberOfSeats: number;
    activationCodes: string[];
  }

  // returned by /api/order/paymentmode; tells the page which checkout to present
  export interface PaymentModeDto {
    provider: string; // "stripe" | "maintenance"
    detectedCountryCode?: string | null;
    isEu: boolean;
    managedPayments: boolean; // Stripe as merchant of record: GBP for all, no manual invoice form
    subscriptionMode: boolean; // managed + recurring Price: auto-renewing annual subscription
    monthlyAvailable: boolean; // + monthly recurring Price: the Monthly/Yearly billing switch shows
  }

  export interface PaymentDtoV2 {
    id: number;
    paymentType: string;
    paymentStatus: string;
    dateTime: string;
    amount: string;
    currency: string;
    invoiceReady: boolean;
    invoiceHtml?: string;
    countryName?: string;
    invoiceUrl?: string; // Stripe-hosted invoice link (Managed Payments orders only)
    isManaged?: boolean; // Managed Payments order: Stripe issues the invoice, never the manual form
}

export interface OrderDtoV2 {
    id: number;
    orderDate: string;
    qnt: number;
    status: string;
    payment?: PaymentDtoV2;
    isRenewal: boolean;
}

export interface ActivationCodeDto {
    code: string;
    isActivated: boolean;
    computerName: string;
}

export interface SubscriptionDtoV2 {
    id: number;
    productName: string;
    qnt: number;
    endDate: string;
    orders: OrderDtoV2[];
    activationCodes: ActivationCodeDto[];
    isBlocked: boolean;
    isExpired: boolean;
    renewalLink?: string;
}

export interface InvoiceDataDto{
    paymentId:number;
    name:string;
    address:string;
    buyersRefNumber?:string;
    invoiceHtml?:string;
}

export interface InvoiceDetailsFormValues {
    name: string;
    address: string;
    buyersRefNumber: string;
  }

export interface RenewSubscriptionDto {
    subscriptionId: number;
    isNotExpiredYet: boolean;
    pricePerUser: number;
    qnt: number;
    productName: string;
    endDate: string;
    renewalDiscount: number;
    currency?: string; // "GBP" or "EUR" (EU visitors)
    // server-resolved renewal mode - the page renders exactly this, never inferring:
    // "legacy" | "autoRenewing" | "renewOrResume" | "payInvoice" | "resubscribe"
    // | "needsAttention"
    renewalMode?: string;
    billingPeriodMonths?: number; // 1 = monthly, 12 = yearly
    nextChargeDate?: string | null;   // current period end, live-subscription modes
    scheduledEndDate?: string | null; // renew-once pending / scheduled cancel
    hostedInvoiceUrl?: string | null; // payInvoice mode, signed-in owner only
    // unused-time credit for an early legacy renewal (legacy mode only). days = 0 hides the row;
    // the amount is server-computed and must be used as-is, never re-derived
    unusedTimeCreditDays?: number;
    unusedTimeCreditAmount?: number;
}

export interface RenewPurchaseDto {
    Url: string;
    SubscriptionId: number;
    Name?: string;
    Address?: string;
    BuyersRefNumber?: string;
    CountryIsoCode?: string;
    InvoiceNeeded: boolean;
    BuyersVatNumber?: string;
    DiscountCode?: string;
  }

export interface PaidRenewOrderDto {
    error: string | null;
    pending: boolean;
    paymentId: number;
    orderId: number;
    subscribtionEndDate: string;
    numberOfSeats: number;
  }

// V3 interfaces matching C# classes
export interface ActivationsV3 {
    computerName: string;
    activationDate: string;
    canBeDeactivated: boolean;
}

export interface ActivationCodeDtoV3 {
    code: string;
    isActivated: boolean;
    activations: ActivationsV3[];
}

export interface SubscriptionDtoV3 {
    id: number;
    productName: string;
    qnt: number;
    endDate: string;
    orders: OrderDtoV2[];
    activationCodes: ActivationCodeDtoV3[];
    isExpired: boolean;
    isBlocked: boolean;
    renewalLink?: string;
    isRecurring?: boolean; // auto-renewing Stripe subscription that can be cancelled/restored
    autoRenew?: boolean;   // live Stripe state: true = renews, false = cancelled (active until end date)
    billingPeriodMonths?: number; // plan cadence from the latest order: 1 = monthly, 12 = annual
    // Stripe's next charge date; can differ from endDate (licence paid further ahead
    // via credited time from an early renewal / mid-licence re-subscribe)
    nextChargeDate?: string | null;
    // raw Stripe status from the billing record ("active" | "trialing" | "past_due" | "canceled" ...),
    // null for legacy subscriptions. "past_due" = the renewal payment failed, Stripe is retrying
    billingStatus?: string | null;
    // Stripe's hosted page for the open (failed) invoice - only while past_due, owner only
    hostedInvoiceUrl?: string | null;
    // a Stripe customer is on record for a live/past-due subscription: the card can be updated
    // (also once the licence has lapsed)
    canUpdatePaymentMethod?: boolean;
}